import {Injectable} from '@angular/core';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';

@Injectable({
  providedIn: 'root'
})
export class NationalityService extends AbstractProdSelectService {
  override selectDataUrl: string = 'nationalities';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'code',
    extraProperties: [{
      name: '',
      value: 'country'
    }]
  };
}
